export const colors = {
  main: "rgba(173,0,0,1)",
  gradient180: "linear-gradient(180deg, #EC1D23 0%, #EC1D23 0%, #871621 100%)",
  gradient90: "linear-gradient(90deg, #EC1D23 0%, #EC1D23 0%, #871621 100%)",
  secondary: "black",
  light: "white",
  gray: "gray",
};
